// views/Map/composables/usePolyline.js
// But: fournir une fonction pure pour transformer une liste de positions
// -> en polylines par tranches de vitesse (<=50, 50-90, >90), formatées pour LPolyline.

export function getPolylineDataFromPositions(rawPositions, thresholds = { low: 50, mid: 90 }) {
    const blue = [];    // <= 50
    const orange = [];  // (50, 90]
    const red = [];     // > 90

    if (!Array.isArray(rawPositions) || rawPositions.length === 0) {
        return { blue, orange, red };
    }

    // Normalisation rapide [Number(lat), Number(lng)] et speed numérique
    const positions = rawPositions
        .map(p => ({
            lat: Number(p.latitude ?? p.lat),
            lng: Number(p.longitude ?? p.lng),
            speed: Number(p.speed ?? 0),
        }))
        .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));

    let currentBucket = null;      // 'blue' | 'orange' | 'red'
    let currentSegment = [];

    const pushSegment = () => {
        if (currentSegment.length <= 1) {
            currentSegment = [];
            return; // segments de 1 point: Leaflet peut les afficher, mais on évite le bruit
        }
        if (currentBucket === 'blue') blue.push(currentSegment);
        if (currentBucket === 'orange') orange.push(currentSegment);
        if (currentBucket === 'red') red.push(currentSegment);
        currentSegment = [];
    };

    const bucketOf = (speed) => {
        if (speed <= thresholds.low) return 'blue';
        if (speed <= thresholds.mid) return 'orange';
        return 'red';
    };

    for (let i = 0; i < positions.length; i++) {
        const { lat, lng, speed } = positions[i];
        const bucket = bucketOf(speed);

        if (currentBucket == null) {
            currentBucket = bucket;
            currentSegment.push([lat, lng]);
            continue;
        }

        if (bucket === currentBucket) {
            currentSegment.push([lat, lng]);
        } else {
            // on clôt le segment précédent, puis on démarre un nouveau
            currentSegment.push([lat, lng]); // inclu le point pivot des deux côtés (visuellement + propre)
            pushSegment();
            currentBucket = bucket;
            currentSegment.push([lat, lng]);
        }
    }

    // dernier segment
    pushSegment();

    return { blue, orange, red };
}

// Corridoring: transforme une liste de positions en polyline simple [[lat,lng], ...]
export function getCorridoringPolyline(rawPositions) {
    if (!Array.isArray(rawPositions)) return [];
    return rawPositions
        .map(p => {
            const lat = Number(p.latitude ?? p.lat);
            const lng = Number(p.longitude ?? p.lng);
            return [lat, lng];
        })
        .filter(([lat, lng]) => Number.isFinite(lat) && Number.isFinite(lng));
}
